import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-6d298fc3.js';
import React, { useState } from 'react';
import WeducCalendar from './weducCalendar.js';
import WeducNewsFeed$2 from './weducFolders.js';
import WeducNewsFeed from './weducNewsfeed.js';
import WeducNewsFeed$1 from './weducNotices.js';
import 'crypto';
import 'react-adaptive-image';
import { getAdaptiveImage } from './imgUtils.js';
import 'react-hook-form';
import '@hcaptcha/react-hcaptcha';
import ContactForm from './contactForm.js';
import 'react-leaflet';
import MapWidget from './mapWidget.js';
import 'escape-html';
import 'slate';
import { serializeNode } from './wigUtils.js';
import moment from 'moment';
import renderHTML from 'react-render-html';
import Modal from 'react-responsive-modal';
import buildMediaContent from './buildMediaContent.js';
import ReactPlayer from 'react-player';
import Loadable from 'react-loadable';
import Viewer, { Worker } from '@phuocng/react-pdf-viewer';
var LoadableCalendar = Loadable({
  loader: function loader() {
    return import('./fullCalendar.js');
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
});

var renderPage = function renderPage(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.svgLayer.children, props.textLayer.children, props.annotationLayer.children);
};

var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
      wrapper = _ref.wrapper,
      children = _ref.children;
  return condition ? wrapper(children) : children;
};

require("es6-promise").polyfill();

var WigLoader = function WigLoader(props) {
  console.log(props);
  var contentDataData = props.contentDataData;
  var contentDataArray = props.contentDataArray;
  var contentDataChild = props.contentDataChild;
  var customDataArray = props.customDataArray;
  var contentMetaData = props.contentMetaData;
  var wigContentArray = [];

  if (customDataArray) {
    wigContentArray = customDataArray;
  } else if (!customDataArray && contentDataData[contentDataArray] && contentDataData[contentDataArray].children && contentDataData[contentDataArray].children[contentDataChild] && contentDataData[contentDataArray].children[contentDataChild].value) {
    wigContentArray = contentDataData[contentDataArray].children[contentDataChild].value;
  }

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      vacancyLoading = _useState2[0],
      setVacancyLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      newsfeedWysLoaded = _useState4[0],
      setNewsfeedWysLoaded = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      calendarData = _useState6[0],
      setCalendarData = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      modalOpen = _useState8[0],
      setModalOpen = _useState8[1];

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      modalData = _useState10[0],
      setModalData = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      numPDFPages = _useState12[0],
      setNumPDFPages = _useState12[1];

  var _useState13 = useState(1),
      _useState14 = _slicedToArray(_useState13, 2),
      pageNumber = _useState14[0],
      setPageNumber = _useState14[1];

  var handleDateClick = function handleDateClick(args) {
    console.log(args);
    var data = {
      title: args.event.title,
      description: args.event._def.extendedProps.description
    };
    setModalData(data);
    setModalOpen(true);
  };

  var checkContent = function checkContent(content) {
    var div = document.createElement("div");
    div.innerHTML = content;
    var image = div.getElementsByTagName("img")[0];

    if (image && !image.getAttribute("src").includes("external")) {
      image.remove();
    }

    return div.outerHTML;
  };

  function convertWigJSON(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return str;
    }

    return JSON.parse(str);
  }

  if (contentDataData && contentMetaData && contentDataArray && contentDataChild) {
    return /*#__PURE__*/React.createElement("div", null, wigContentArray && wigContentArray !== [] ? /*#__PURE__*/React.createElement(React.Fragment, null, convertWigJSON(wigContentArray) && convertWigJSON(wigContentArray).length >= 0 && /*#__PURE__*/React.createElement(React.Fragment, null, convertWigJSON(wigContentArray).map(function (item, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i
      }, item.type && item.type === "layout" ? /*#__PURE__*/React.createElement("div", {
        className: "content-layout-wrapper"
      }, item && item.children && item.children.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "content-layout-inner-block"
      }, item.children.map(function (child, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "content-layout-inner-block-child"
        }, renderHTML(serializeNode(child)));
      }))) : item.type && item.type === "contact-form" ? /*#__PURE__*/React.createElement("div", {
        className: "contact-form-wrap",
        id: "contact-form"
      }, /*#__PURE__*/React.createElement(ContactForm, {
        AccroPressProdEndpoint: props.AccroPressProdEndpoint,
        AccroPressLocalEndpoint: props.AccroPressLocalEndpoint,
        integratorID: props.integratorID,
        integratorAccessToken: props.integratorAccessToken
      })) : item.type && item.type === "image-gallery" ? /*#__PURE__*/React.createElement("div", {
        className: "image-gallery-wrap",
        style: {
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement("section", {
        className: "ap-wig-gallery"
      }, item && item.images && item.images.length > 0 && /*#__PURE__*/React.createElement("ol", null, item.images.map(function (image, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: index,
          index: index,
          "data-model-image": image.url,
          style: {
            backgroundImage: "url(".concat(image.url, ")")
          }
        });
      })))) : item.type && item.type === "img" && item.url.indexOf(".pdf") != -1 ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(Worker, {
        workerUrl: "https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.min.js"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, /*#__PURE__*/React.createElement(Viewer, {
        fileUrl: item.url,
        renderPage: renderPage
      })))) : item.type && item.type === "image" && item.url.indexOf(".pdf") != -1 ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(Worker, {
        workerUrl: "https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.min.js"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, /*#__PURE__*/React.createElement(Viewer, {
        fileUrl: item.url,
        renderPage: renderPage
      })))) : item.type && (item.type === "image" || item.type === "img") ? /*#__PURE__*/React.createElement("div", {
        className: "image-position-".concat(item.position, " ").concat(item.classname)
      }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
        condition: item.link,
        wrapper: function wrapper(children) {
          return /*#__PURE__*/React.createElement("a", {
            href: item.link
          }, children);
        }
      }, item.url.includes("https://cdn2.accropress.com") ? getAdaptiveImage(item.url, item.isBackgroundImage || false, "wig-image ".concat(item.className), item.alt || "An image", parseInt(item.width, 10), parseInt(item.height, 10), parseInt(item.quality, 10), item.auto, item.crop, item.focalcrop) : /*#__PURE__*/React.createElement("img", {
        width: parseInt(item.width, 10),
        height: parseInt(item.height, 10),
        src: item.url,
        alt: item.alt || "An image"
      }))) : item.type && item.type === "file" && item.extension === "pdf" ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(Worker, {
        workerUrl: "https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.min.js"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, /*#__PURE__*/React.createElement(Viewer, {
        fileUrl: item.url,
        renderPage: renderPage
      })))) : item.type && item.type === "video" ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(ReactPlayer, {
        width: "100%",
        height: "450px",
        url: item.url,
        light: true,
        controls: true,
        volume: undefined
      })) : item.type && item.type === "map" ? /*#__PURE__*/React.createElement("div", {
        className: "wig-map-wrap"
      }, /*#__PURE__*/React.createElement(MapWidget, {
        latitude: item.latitude,
        longitude: item.longitude,
        zoom: item.zoom,
        pitch: item.pitch,
        bearing: item.bearing,
        scrollZoom: item.scrollZoom,
        pitchWithRotate: item.pitchWithRotate,
        dragRotate: item.dragRotate
      })) : item.type && item.type === "weduc-widget-newsfeed" ? /*#__PURE__*/React.createElement("div", {
        className: "weducWidgetDisplay_" + newsfeedWysLoaded
      }, /*#__PURE__*/React.createElement(WeducNewsFeed, {
        limit: 5,
        name: props.weducWebsitesID || "",
        container: item.weducComponentID || "",
        pagination: true,
        loadedEvent: setNewsfeedWysLoaded,
        html: function NewsFeedTemplate(props) {
          return /*#__PURE__*/React.createElement("div", {
            className: "newsFeedItem"
          }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
            className: "newsFeedItem_Date"
          }, moment(props.data.start_date).format("LL")), /*#__PURE__*/React.createElement("div", {
            className: "newsFeedItem_Item",
            dangerouslySetInnerHTML: {
              __html: checkContent(props.data.contentHtml)
            }
          }), /*#__PURE__*/React.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: buildMediaContent(props.data.postType)
            }
          })));
        },
        route: contentMetaData.slug
      })) : item.type && item.type === "weduc-widget-calendar" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LoadableCalendar, {
        handleDateClick: handleDateClick,
        calendarData: calendarData
      }), /*#__PURE__*/React.createElement(Modal, {
        classNames: {
          modal: "AccroModal"
        },
        open: modalOpen,
        onClose: function onClose() {
          return setModalOpen(false);
        },
        center: true
      }, /*#__PURE__*/React.createElement("h2", null, modalData.title), /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: modalData.description
        }
      })), /*#__PURE__*/React.createElement(WeducCalendar, {
        name: props.weducWebsitesID || "",
        container: item.weducComponentID,
        route: contentMetaData.slug,
        state: calendarData,
        loadedEvent: setNewsfeedWysLoaded,
        setState: setCalendarData
      })) : item.type && item.type === "weduc-widget-notices" ? /*#__PURE__*/React.createElement("div", {
        className: "weducWidgetDisplay_" + newsfeedWysLoaded
      }, /*#__PURE__*/React.createElement(WeducNewsFeed$1, {
        delay: 5,
        limit: 5,
        name: props.weducWebsitesID || "",
        container: item.weducComponentID,
        html: function NewsFeedTemplate(props) {
          return /*#__PURE__*/React.createElement("div", {
            className: "noticesItem"
          }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, props.data.title, props.data.snippet && ": "), props.data.snippet));
        },
        loadedEvent: setNewsfeedWysLoaded
      })) : item.type && item.type === "weduc-widget-folders" ? /*#__PURE__*/React.createElement("div", {
        className: "weducWidgetDisplay_" + newsfeedWysLoaded
      }, /*#__PURE__*/React.createElement(WeducNewsFeed$2, {
        name: props.weducWebsitesID || "",
        container: props.weducContainer,
        entity: props.weducEntity,
        folderID: item.weducComponentID,
        html: function NewsFeedTemplate(props) {
          return /*#__PURE__*/React.createElement("div", {
            className: "foldersItem"
          }, /*#__PURE__*/React.createElement("a", {
            className: "ap-file-component",
            target: "_blank",
            href: props.data.external_url
          }, /*#__PURE__*/React.createElement("div", {
            className: "ap-file-component-extension"
          }, props.data.external_url.split(".").pop()), /*#__PURE__*/React.createElement("div", {
            className: "ap-file-component-filename"
          }, props.data.title)));
        },
        loadedEvent: setNewsfeedWysLoaded
      })) : /*#__PURE__*/React.createElement("div", null, renderHTML(serializeNode(item))));
    }))) : /*#__PURE__*/React.createElement("p", null, "No content found."));
  } else {
    return /*#__PURE__*/React.createElement("p", null, "Error: Content meta was supplied incorrectly to WigLoader");
  }
};

export default WigLoader;